module.exports = __webpack_public_path__ + "img/Desktop_Slide2.a19a8b4b.svg";